import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  filter(event) {
    const selectedAirportCode = event.target.value
    const url = new URL(window.location.href)
    url.searchParams.set('airport_code', selectedAirportCode)
    window.location.href = url.toString()
  }

  reset() {
    const url = new URL(window.location.href)
    url.searchParams.set('airport_code', 'all')
    window.location.href = url.toString()
  }
}
